import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Alert from 'components/Alert';
import DateOfServiceError from '../DateOfServiceError';

const StyledAlert = styled(Alert)`
  margin-top: 16px;
`;

const EditClaimError = ({ error, isVisible }) => {
  if (!isVisible) {
    return null;
  }
  if (error?.message === 'No contract found for given Date of Service') {
    return <DateOfServiceError />;
  }
  if (error?.message?.includes('400 - AltBeneficiary Client Id is already exists')) {
    return (
      <StyledAlert variant="danger" label="Check your passport number">
        The given passport number is already in use. If your passport number is correct in
        the form, please contact customer service.
      </StyledAlert>
    );
  }
  if (
    error?.message?.includes('Could not find entity in table MemberExpaTPA with userID')
  ) {
    return (
      <StyledAlert variant="danger" label="Something went wrong">
        We are experiencing some issues. Please try again in a minute, and if the problem
        persists, contact customer service.
      </StyledAlert>
    );
  }
  return (
    <StyledAlert variant="danger" label="Something went wrong">
      Something went wrong with saving your information. Please try again, and if the
      problem persists, contact customer service.
    </StyledAlert>
  );
};

EditClaimError.propTypes = {
  error: PropTypes.object,
  isVisible: PropTypes.bool
};

export default EditClaimError;
